import React, { Component } from "react";
import quizJSON from "../../api/quiz.json"
import "./QuizScreen.scss"
import { vPush } from "../Services/Analytics";
import Helmet from "react-helmet"

class QuizScreen extends Component {
    constructor(props) {
        super();
        this.state = {
            current: 0,
            busy: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.saveAndValidate = this.saveAndValidate.bind(this);
        this.navigate = this.navigate.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.goToElement = this.goToElement.bind(this);
        this.getSummery = this.getSummery.bind(this);
    }
    componentDidMount() {
        this.setState({
            Takanon: this.props.Takanon
        })
        vPush(`${quizJSON[0].title}`, `${window.location.pathname}quiz/1`)
    }
    getQuestions() {
        return quizJSON.map((item, index) =>
            <QuizzQuestion key={index}
                index={index}
                item={item}
                questions={item.q}
                limit={Math.round(quizJSON.length - 1)}
                handleInputChange={this.handleInputChange}
                handleClick={this.handleClick}
                current={this.state.current}
            />
        )
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: {
                name: event.target.name,
                value: event.target.value,
                error: null
            }
        })
    }
    handleClick() {
        if (!this.state.busy) {
            window.setTimeout(() => {
                this.navigate(Math.round(this.state.current + 1));
                this.setState({
                    busy: false
                })
            }, 1000);
        }
        this.setState({
            busy: true
        })
    }

    getSummery() {
        var valueArr = []
        for (var i = 0; i < quizJSON.length; i++) {
            if (this.state[`question${i}`]) {
                valueArr.push(parseInt(this.state[`question${i}`].value));
            }
        }

        return this.getMostFrequentVal(valueArr);
    }

    getMostFrequentVal(valueArr){
        let mf = 1, m = 0, item;
        for (let i = 0; i < valueArr.length; i++) {
            for (let j = i; j < valueArr.length; j++){
                if (valueArr[i] == valueArr[j])
                    m++;
                if (mf < m){
                    mf = m; 
                    item = valueArr[i];
                }
            }
            m=0;
        }
        return item;
    }

    navigate(_num) {
        if (_num > quizJSON.length - 1) {
            this.props.hidonState(this.state);
            var whoami = this.getSummery();
            window.location.href = `./#/whoami/${whoami}`;
            return;
        }

        var num = (_num > quizJSON.length - 1 ? quizJSON.length - 1 : _num);
        num = (_num < 0 ? 0 : _num);

        vPush(`${quizJSON[num].title}`, `${window.location.pathname}quiz/${num + 1}`)
        this.setState({
            current: num
        })
    }
    goToElement(index) {
        if (this.state["question" + index] || this.state["question" + Math.round(index - 1)]) {
            this.navigate(index);
        }
    }
    getNavigation() {
        return quizJSON.map((item, index) =>
            <Navigation key={index}
                index={index}
                item={item}
                goToElement={this.goToElement}
                current={this.state.current}
            />)
    }
    saveAndValidate() {
        debugger;
        const state = this.state;
        const Parent = this.props.state;
        var trueCounter = 0;
        var counter = 0;

        if (state.question0) {
            counter++
        }
        if (state.question1) {
            counter++
        }
        if (state.question2) {
            counter++
        }
        if (state.question0 && state.question0.value == "true") {
            trueCounter++;
        }
        if (state.question1 && state.question1.value == "true") {
            trueCounter++;
        }
        if (state.question2 && state.question2.value == "true") {
            trueCounter++;
        }

        if (counter < 3) {
            alert("לא ניתן לשלוח את החידון מבלי לענות על כל השאלות");
            return false;
        }
    }
    render() {
        return (
            <section className="section section-hidon">
                <div className="padding">
                    <div className="container">
                        {this.getQuestions()}
                        <div className="nav">
                            <div className="line"></div>
                            <div className="circles">
                                {this.getNavigation()}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const Navigation = (props) => {
    return (
        <div onClick={() => props.goToElement(props.index)} className={`circle${(props.current == props.index ? " current" : "")}${(props.current > props.index ? " active" : (props.current == null ? (props.index == 0 ? " active" : "") : ""))}`}>
            {Math.round(props.index + 1)}
        </div>
    )
}

const QuizzQuestion = (props) => {
    return (
        <div className={`quizz${(props.current == props.index ? " active" : (props.current == null ? (props.index == 0 ? " active" : "") : ""))}${(props.index == props.limit ? " last" : "")}`}>
            <div className="quizz-container">
                <div className="num">{`שאלה ${Math.round(props.index + 1)}`}</div>
                <div className="headline">
                    <div className="head">
                        <h4>{props.item.title}</h4>
                    </div>
                </div>
                <div className="questions">
                    {
                        props.questions.map((item, index) =>
                            <DomRadioField key={index}
                                value={index + 1}
                                label={item.name}
                                type="radio"
                                name={`question${props.index}`}
                                id={`question${props.index}_${index}`}
                                onChange={props.handleInputChange}
                                onClick={props.handleClick} />
                        )
                    }
                </div>
            </div>
        </div>
    )
}

const DomRadioField = (props) => {
    return (
        <div className="field">
            <input type={props.type} placeholder={props.placeholder} name={props.name} id={props.id} value={props.value} onClick={props.onClick} onChange={props.onChange} />
            <label htmlFor={props.id}>
                {props.label}
            </label>
        </div>
    )
}

export default QuizScreen;



// WEBPACK FOOTER //
// ./src/Components/Hidon/QuizScreen.js